<div class="container">
  <div class="row">
    <div class="col-3"style="margin: 15px 0;">
      <img src="./assets/evnomia.jpg" alt="Эвномия аудит" style="width: 130px">
    </div>
    <div class="col">
      <div class="container">
        <div class="row justify-content-end">
          <div style="margin: 15px 0;text-align: right"><span class="h3" style="text-align: right; white-space: nowrap;">+7 (905) 795 27 37</span> </div>

          <!-- Force next columns to break to new line -->
          <div class="w-100"></div>

          <div>
            <nav class="navbar navbar-expand-lg  navbar-light bg-light">
              <a class="navbar-brand" href="#">Меню</a>
              <button class="navbar-toggler" type="button" (click)="click()">
                <span class="navbar-toggler-icon"></span>
              </button>
            <div class="container-fluid">
              <div class="collapse navbar-collapse" id="navbarNav" #nav>
                <ul class="navbar-nav">
                  <li class="nav-item">
                    <a class="nav-link" aria-current="page" href="/">Система управления</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="/quality">Контроль качества</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="/independence">Независимость</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="/contacts">Контакты</a>
                  </li>
                </ul>
              </div>
            </div>
          </nav></div>

        </div>
      </div>

    </div>
  </div>
</div>
<div class="col bunner" >
  <div class="back_dark" style="opacity:0.83; background:linear-gradient(to bottom, #ffffff 0% ,#ffffff 100% ) "></div>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="title"> <font color="#444444" face="montserrat"><span style="font-size: 72px;"><b>Аудиторские услуги</b></span></font></div>
        <div class="sub_title"><p><span style="font-size:40px"><span style="font-family:montserrat"><span style="color:#000000">Недочеты в вашем бухучете раньше контролирующих органов</span></span></span></p><p><br></p><p><strong><span style="color:#111111;">✓</span><span style="color:#40E0D0">&nbsp; </span></strong><span style="color:#000000">Лучшие специалисты своего дела</span></p><p><strong><span style="color:#006699"></span><span style="color:#111111">✓</span><span style="color:#006699"></span></strong><span style="color:#40E0D0"><strong>&nbsp;</strong></span><span style="color:#000000">&nbsp;Доступная стоимость услуг</span></p><p><strong><span style="color:#006699"></span><span style="color:#111111">✓</span><span style="color:#006699"></span></strong><span style="color:#40E0D0"><strong>&nbsp;</strong></span><span style="color:#000000">&nbsp;100% гарантия качества</span></p><p><br></p></div>
      </div>
    </div>
  </div>
</div>

